// Shared "250KG Dynamic" seal — used on the Hard Lids category page hero,
// the store tiles and every Tour Top Cover product page. A medallion: a
// bold "250" with a "KG" unit sat on its baseline reads clearly even at
// small sizes, with a thin inner ring for a "stamped seal" feel.
const SIZES = {
  sm: {
    circle: "w-20 h-20 md:w-24 md:h-24",
    ring: "border-2",
    num: "text-2xl md:text-3xl",
    unit: "text-xs md:text-sm",
    showLabel: true,
    label: "text-[8px] md:text-[9px]",
  },
  md: {
    circle: "w-32 h-32 md:w-36 md:h-36",
    ring: "border-[3px]",
    num: "text-3xl md:text-4xl",
    unit: "text-sm md:text-base",
    showLabel: true,
    label: "text-[9px] md:text-[10px]",
  },
};

export const LoadRatingBadge = ({ size = "md", caption, className = "", testId = "load-rating-badge" }) => {
  const s = SIZES[size] || SIZES.md;

  return (
    <div className={`flex flex-col items-center text-center shrink-0 ${className}`} data-testid={testId}>
      <div
        title="250kg dynamic load rated"
        className={`relative rounded-full ${s.ring} border-[var(--brand-primary)] bg-black/55 backdrop-blur-sm flex flex-col items-center justify-center ${s.circle}`}
      >
        <div className="absolute inset-[3px] rounded-full border border-[var(--brand-primary)]/35" />
        <p className={`font-display ${s.num} text-white leading-none flex items-baseline gap-0.5`}>
          250<span className={`${s.unit} text-[var(--brand-primary)] font-sans font-bold`}>KG</span>
        </p>
        {s.showLabel && (
          <p className={`font-mono ${s.label} tracking-[0.15em] uppercase text-white/70 mt-1.5`}>Dynamic</p>
        )}
      </div>
      {caption && (
        <p className="font-mono text-[10px] tracking-[0.2em] uppercase text-white/80 mt-2 max-w-[140px] leading-snug">{caption}</p>
      )}
    </div>
  );
};
